import React from 'react';
import { useTheme } from '@mui/material';
import { SubTypeWidget } from '../../types';
import { StyledWidgetAdditionalOptionItem } from './style';
import { useFormContext } from 'react-hook-form';

type Props = {
  subType: SubTypeWidget;
  activeOption: string;
  handleClose: () => void;
  setSelectedWidgetSubType?: (subType: string) => void;
};

export const WidgetAdditonalOptionItem = ({
  subType,
  activeOption,
  handleClose,
  setSelectedWidgetSubType,
}: Props) => {
  const theme = useTheme();
  const { name } = subType;
  const isActive = activeOption === name;
  const { setValue } = useFormContext();

  const icon = React.createElement(subType?.icon, { width: 50, height: 50, fill: '#b3b3b3' });

  const onClickHandler = () => {
    setValue('widgetSubType', name);
    setSelectedWidgetSubType?.(name);
    handleClose();
  };

  return (
    <StyledWidgetAdditionalOptionItem theme={theme} isActive={isActive} onClick={onClickHandler}>
      {icon}
    </StyledWidgetAdditionalOptionItem>
  );
};
